function searchVendors () {
  const filter = document.getElementById('search-vendors-input').value
  const ul = document.getElementById('vendors-home-list')
  const li = ul.getElementsByTagName('li')
  for (let i = 0; i < li.length; i++) {
    const elemText = li[i].getElementsByTagName('a')[0].text
    li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
  }
}
const searchVendorInput = $('#search-vendors-input')
searchVendorInput.on('keypress', function (e) {
  if (e.which === 13) {
    window.location.href = $('#vendors-home-list li a:visible:first').attr('href')
  }
})
searchVendorInput.focusin(function () {
  $('#vendors-home-list').fadeIn('fast')
})
searchVendorInput.focusout(function () {
  $('#vendors-home-list').fadeOut(1000)
})
searchVendorInput.on('keyup', function () { searchVendors() })

$('.mobileMainSlider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
})

$('.home-cat-tabs-prod-slider').slick({
  arrows: true,
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3.5,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 650,
      settings: {
        arrows: false,
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 500,
      settings: {
        arrows: false,
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    }
  ]
})

$('.homeCatListTabs').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
})
$('#homeCatList-1 ul.homeCatListTabs li:first-child').addClass('current')
$('#homeCatList-1 .cat-list-tab-wrapper .row:first-child .cat-list-tab-content').addClass('current')
$('#homeCatList-1 ul.homeCatListTabs li').on('click', function () {
  $('#homeCatList-1 .cat-list-tab-wrapper .row:first-child .cat-list-tab-content').removeClass('current')
  var tab_id = $(this).attr('data-tab')
  $('#homeCatList-1 ul.homeCatListTabs li').removeClass('current')
  $('#homeCatList-1 .cat-list-tab-content').removeClass('current')
  $(this).addClass('current')
  $('#homeCatList-1 #'+tab_id).addClass('current')
  return false
})


$('.home-banners-mob-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.pharmado_caption_slider, .pharmado_brand_slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: false,
        centerPadding: '12.5%'
      }
    }
  ]
})

$('.pharmado_top_brand_slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: '12.5%'
      }
    }
  ]
})

$('.pharmado_trending_now_slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3.8,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: '12.5%'
      }
    }
  ]
})

$('.pharmadoHomeNewEntries,.pharmadoHomeTopProducts').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: '12.5%'
      }
    }
  ]
})

// $('.slider-wrapper-flex').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 5000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 450,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

$('.vendors_slider_home').slick({
  lazyLoad: 'ondemand',
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 8,
  slidesToScroll: 8,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 359,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
})

$('.three-col-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: '12.5%'
      }
    }
  ]
})

$('.three-col-split-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        centerPadding: '12.5%'
      }
    }
  ]
})

// $('.home-bc-slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 8,
//   slidesToScroll: 8,
//   responsive: [
//     {
//       breakpoint: 5000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

$('.home-tabs-prod-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 9999,
      settings: 'unslick'
    },
    {
      breakpoint: 1200,
      settings: {
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
})

$(document).ready(function () {
  $('.product-offer-slider-wrapper').slick({
    fade: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 575,
        settings: {
          fade: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  })
})

$('.product-slider-wrapper').slick({
  fade: true,
  cssEase: 'linear'
})

$('.offer_card_countdown [data-countdown]').each(function () {
  const $this = $(this)
  const finalDate = $(this).data('countdown')
  $this.countdown(finalDate, function (event) {
    $this.html(event.strftime('<span>%H<span class="countdown_info">Hrs</span></span><span>%M<span class="countdown_info">Mins</span></span><span>%S<span class="countdown_info">Secs</span></span>'))
  })
})
